module.exports = __webpack_public_path__ + "img/关于我们.47d437c2.svg";